/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IFeeRecipient, IFeeRecipientInterface } from "../IFeeRecipient";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "receiveZeroExFeeCallback",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IFeeRecipient__factory {
  static readonly abi = _abi;
  static createInterface(): IFeeRecipientInterface {
    return new utils.Interface(_abi) as IFeeRecipientInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IFeeRecipient {
    return new Contract(address, _abi, signerOrProvider) as IFeeRecipient;
  }
}
